import classnames from 'classnames';
import React from 'react';
import styles from './styles.scss';

export default function(){
	return (
		<section className={styles['ac-success']}>
			<div className={styles['success-tips']}></div>
			<h1>Thank you for your Submission!</h1>
			<p>A team member will be in-touch with you within 24 hrs.</p>
			<p>If you have any questions please reach out to us at contact@air-class.com</p>
		</section>
	);
}

